export let TimeRadioOptions = /*#__PURE__*/function (TimeRadioOptions) {
  TimeRadioOptions["WITHIN_THE_LAST"] = "withinTheLast";
  TimeRadioOptions["BETWEEN"] = "between";
  return TimeRadioOptions;
}({});